//https://www.geeksforgeeks.org/how-to-check-a-webpage-is-loaded-inside-an-iframe-or-into-the-browser-window-using-javascript/
export default function isIFrame(): boolean {
	return window.location !== window.parent.location;
}
